export default __webpack_public_path__ + "static/media/Html-css-js.e162d865.svg";